<template>
  <router-view></router-view>
</template>

<script>


// import Vue from 'vue'
// import GoogleLogin from 'vue-google-login';
// import { LoaderPlugin } from 'vue-google-login';
// Vue.use(LoaderPlugin, {
//     client_id: "183021784010-8ofllk87t4h5nncedsbp6bn8hp6m54p0.apps.googleusercontent.com"
// });


export default {
    name: 'App',

    components: {
    },

    data() {
        return {
            // User state is checked in 'beforeMount' and then 'mount' is triggered
            //beforeMountPromise: null,
        }
    },

    methods: {

    }

}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
